import { ThemeOptions } from '@eclo/mode'
import { themeColors } from './theme.colors'

export const themeConfig: ThemeOptions = {
	fonts: {
		textFamily: `'Roboto', sans-serif`,
		titleFamily: `'Roboto', sans-serif`,
	},

	sizes: {
		header: {
			mobile: {
				num: 70,
				unit: 'px',
			},
		},
		footer: {
			mobile: {
				num: 72,
				unit: 'px',
			},
		},
		gutter: {
			mobile: {
				num: 20,
				unit: 'px',
			},
			tablet: {
				num: 40,
				unit: 'px',
			},
			sdesk: {
				num: 2,
				unit: 'vw',
			},
		},
		font: {
			h1: {
				num: 2.5,
				unit: 'rem',
			},
			h2: {
				num: 2,
				unit: 'rem',
			},
			h3: {
				num: 2,
				unit: 'rem',
			},
			h4: {
				num: 1.667,
				unit: 'rem',
			},
			h5: {
				num: 1.5,
				unit: 'rem',
			},
			base: {
				num: 12,
				unit: 'px',
			},
		},
	},

	colors: themeColors,
}
